<template>
  <b-modal v-model="show" :title="$t('config.products.productManufacture.title')" :no-close-on-esc="true"
           :no-close-on-backdrop="true">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <div class="form-group">
              <label>Категория <span class="red">*</span></label>
              <v-select v-model="productManufacture.productCategory" label="name"
                        :options="categories"
                        :filterable="false"
                        @search="onCategorySearch"
                        @search:focus="onCategoryFocus">
                <template slot="option" slot-scope="option" v-if="option">
                  <div v-html="option.name"></div>
                </template>
                <template slot="selected-option"
                          v-if="productManufacture && productManufacture.productCategory && productManufacture.productCategory.text">
                  <div v-html="productManufacture.productCategory.text"
                       @click="$eventBus.$emit('search:focus')"></div>
                </template>
                <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
              </v-select>
            </div>

            <div class="form-group">
              <label>{{ $t('config.products.productSubCategory.title') }}<span class="red">*</span></label>
              <v-select v-model="productManufacture.productSubCategory" label="name"
                        :options="subCategories"
                        :filterable="false"
                        @search="onSubCategorySearch"
                        @search:focus="onSubCategoryFocus">
                <template slot="option" slot-scope="option" v-if="option">
                  <div v-html="option.name"></div>
                </template>
                <template slot="selected-option"
                          v-if="productManufacture.productSubCategory && productManufacture.productSubCategory && productManufacture.productSubCategory.text">
                  <div v-html="productManufacture.productSubCategory.text"
                       @click="$eventBus.$emit('search:focus')"></div>
                </template>
                <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
              </v-select>
            </div>

          </div>
          <div class="form-group">
            <label>Номи <span class="red">*</span></label>
            <input
                type="text"
                class="form-control"
                v-model="productManufacture.name"
                :class="{'is-invalid': $v.productManufacture.name.$error}"
                @blur="$v.productManufacture.name.$touch()"
            />
            <div class="red" v-if="$v.productManufacture.name.$error">Номи</div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
      <button class="all-btn add-btn float-right" @click="save">
        Сақлаш
      </button>
      <button class="all-btn delete-btn float-right mr-2" @click="cancel">
        Бекор қилиш
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
import {clone} from '@/shared/utils';
import {required} from 'vuelidate/lib/validators'
import initFilterModel from '@/shared/filter';

export default {
  name: "ProductManufactureAddView",
  components: {
    'b-modal': bModal
  },
  directives: {
    'b-modal': bModalDirective
  },
  data() {
    return {
      show: false,
      processing: false,
      categoryFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      productManufacture: {},
      subCategories: [],
      categories: []
    }
  },
  validations: {
    productManufacture: {
      name: {
        required: required
      }
    }
  },
  methods: {
    cancel() {
      this.show = false;
    },
    initData() {
      this.processing = true;

      if (!this.productManufacture.id) {
        return;
      }

      const vm = this;

      this.$http.get('product-manufacture/' + this.productManufacture.id).then(res => {
        vm.processing = false;
        vm.productManufacture = res.data;
      }, err => {
        vm.processing = false;
        console.log(err);
      });
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const vm = this;
      this.processing = true;

      this.$http.post('product-manufacture/save', this.productManufacture)
          .then(res => {
            vm.processing = false;
            const response = res.data;
            if (response.statusCode === 'OK') {
              vm.show = false;
              this.$eventBus.$emit('productManufactureChanged', response);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.message,
                type: 'warning'
              });
            }
          }, err => {
            vm.processing = false;
            console.log(err);
          });
    },
    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.categoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },

    onCategoryFocus() {
      this.categoryFilter.search = '';
      this.searchMethodCategory();
    },

    searchMethodCategory(loading) {
      this.productCategories = [];
      this.productSubCategories = [];
      this.$http.post('product-category-plus/search', this.categoryFilter).then(res => {
        if (loading)
          loading(false);
        this.categories = res.data.data;
      }, err => {
        console.log(err);
      });
    },

    onSubCategorySearch(searchTxt, loading) {
      if (!this.productManufacture.productCategory) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.productManufacture.productCategory.id;
      this.searchMethodSubCategory(loading);
    },
    onSubCategoryFocus() {
      if (!this.productManufacture.productCategory) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.productManufacture.productCategory.id;
      this.searchMethodSubCategory();
    },
    searchMethodSubCategory(loading) {
      this.subCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.subCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    }
  },
  created() {
    this.initData()
    this.$eventBus.$on('showProductManufactureModal', (data) => {
      if (data) {
        this.productManufacture = clone(data);
      } else {
        this.productManufacture = {}
      }
      this.show = true;
    });
  }
}
</script>

<style scoped>

</style>